import Backbone from 'backbone';
import _ from 'underscore';
import { DependencyResolver } from '@bingads-webui-campaign/dependency-resolver';
import template from './audience-meter.pug';

/**
 * AudienceMeter class
 * This is a pure view for the Meter-Needle portion of the Reach Estimate Control
 *
 * @class AudienceMeter
 */
export class AudienceMeter extends Backbone.View {
  initialize() {
    this.i18n = DependencyResolver.get('component/i18n/loader!campaignui/feature/audience-campaign');

    this.meterProps = {
      value: 0,
      max: 100,
      min: 0,
    };
  }

  /**
   * Renders the view
   *
   * @returns {View} returns the view itself
   */
  render() {
    this.$el.html(template({ i18n: this.i18n }));

    return this;
  }

  /**
   * Show Audience Meter
   * @private
   *
   * @returns {undefined}
   */
  show() {
    this.$el.show();
  }

  /**
   * Hide Audience Meter
   * @private
   *
   * @returns {undefined}
   */
  hide() {
    this.$el.hide();
  }

  /**
   * Move the arrow pointer along the broad meter scale
   *
   * @param {Number} value value to which the the pointer should be moved
   * @returns {undefined}
   */
  moveAlongBroad(value) {
    this.$('.arrow').css({ left: this.calcBroadPos(value) });
    this.$('.arrow').css('border-top-color', 'green');
  }

  /**
   * Move the arrow pointer to the specific meter category
   *
   * @returns {undefined}
   */
  moveToSpecific() {
    const midPointVal = 50; // percentage

    this.$('.arrow').css({ left: this.calcSpecificPos(midPointVal) });
    this.$('.arrow').css('border-top-color', 'red');
  }

  /**
   * Helper to calculate pointer position along broad scale
   * @private
   *
   * @param {Number} value to which the the pointer should be moved
   * @returns {Number} position in pixels
   */
  calcBroadPos(value) {
    const specificMeterSize = this.$('.specific-meter').width();
    const broadMeterSize = this.$('.broad-meter').width();
    const arrowGap = _.first(this.$('.arrow').css('borderLeftWidth'));

    const broadScalePos = value * ((broadMeterSize - arrowGap) / this.meterProps.max);

    // Offset final position with specific meter width
    return specificMeterSize + broadScalePos;
  }

  /**
   * Helper to calculate pointer position along specific scale
   * @private
   *
   * @param {Number} value to which the the pointer should be moved
   * @returns {Number} position in pixels
   */
  calcSpecificPos(value) {
    const specificMeterSize = this.$('.specific-meter').width();
    const arrowGap = _.first(this.$('.arrow').css('borderLeftWidth'));

    return value * ((specificMeterSize - arrowGap) / this.meterProps.max);
  }
}
